import { useUserData } from '../../../../hooks'
import { getUserAvatar } from '../../../../utils/user'
import { Avatar } from '../../../Avatar'
import { EmailReplyForm } from '../../EmailReplyForm'
import { EmailReplyFormActions } from '../../EmailReplyFormActions'

import * as styles from './EmailProfileMessageReplyForm.module.css'

function EmailProfileMessageReplyForm({
  className = styles.EmailProfileMessageReplyForm,
  formFieldsProps,
  ...restProps
}) {
  const currentUser = useUserData()

  return (
    <div className={className}>
      <Avatar {...getUserAvatar(currentUser)} />

      <EmailReplyForm
        {...restProps}
        formFieldsProps={{ ...formFieldsProps, Actions: EmailReplyFormActions }}
      />
    </div>
  )
}

export default EmailProfileMessageReplyForm
